<!-- <div
	class="flex gap-1 flex-wrap p-4 bg-neutral-50 dark:bg-neutral-900 rounded-3xl mb-4">
	@for (feature of recordData().featureItems; track feature.id) {
		<span
			class="px-4 py-2 rounded-full bg-neutral-800 text-white dark:bg-neutral-50 dark:text-black"
			>{{ feature.title | transloco }}</span
		>
	}
</div> -->

@if (!isLoading()) {
	<form [formArray]="form" class="grid grid-cols-1 md:grid-cols-2 gap-4">
		@for (item of controlsMap(); let i = $index; track item.featureItem.uuid) {
			<app-toggle-new
				[label]="item.featureItem.title"
				[formControl]="form.at(i)" />
		}
	</form>
} @else {
	<div class="flex items-center justify-center h-50" @fadeIn>
		<app-loading-spinner />
	</div>
}
